import React, { Component } from 'react';

class Dialog extends Component {
  render() {
    return (
      <div className={ this.props.isShow ? "dialog-wrapper" : 'dialog-wrapper hide' }>
        {this.props.children}
        <div className="dialog-mask"></div>
      </div>
    )
  }
}

export default Dialog;
